/* React */
import React from "react";

/* Stylesheet */
import styles from "./IllustrationContainer.module.scss";

const IllustrationContainer: React.FC = () => {
  return (
    <div className={styles.illustration_container}>
      <div className={styles.illustration} />
    </div>
  );
};

export default IllustrationContainer;
